import { render, staticRenderFns } from "./DomainSummaryTop5Dealer.vue?vue&type=template&id=d63dc196&scoped=true"
import script from "./DomainSummaryTop5Dealer.vue?vue&type=script&lang=js"
export * from "./DomainSummaryTop5Dealer.vue?vue&type=script&lang=js"
import style0 from "./DomainSummaryTop5Dealer.vue?vue&type=style&index=0&id=d63dc196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63dc196",
  null
  
)

export default component.exports